export default __webpack_public_path__ + "static/media/avatar-outline-16px.d9239a50.svg";